import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styled';

const sizes = {
  large: ['64px', '64px'],
  xlarge: ['128px', '128px'],
  default: ['32px', '32px'],
};

const Spinner = (props) => {
  const size =
    typeof props.size === 'string'
      ? sizes[props.size] || sizes.default
      : props.size;
  const [width, height] = size;

  if (!props.show) {
    return null;
  }

  return (
    <S.Spinner
      minHeight={props.minHeight}
      style={props.style}
    >
      <S.BarContainer style={{ width, height }}>
        <S.FirstBar />
        <S.SecondBar />
        <S.ThirdBar />
      </S.BarContainer>
    </S.Spinner>
  );
};

Spinner.defaultProps = {
  size: 'default',
  minHeight: null,
  show: true,
  style: {},
};

Spinner.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.oneOf(['large', 'xlarge', 'default']),
    PropTypes.array,
  ]),
  minHeight: PropTypes.number,
  show: PropTypes.bool,
  style: PropTypes.object,
};

export default Spinner;
